import { isValidElement } from 'react';

import { Box, Typography, TypographyStyle } from '@mui/material';

import { DisplayCurrency } from 'src/components';

export interface RiskCardProps {
    label: string;
    value: string | number | React.ReactNode;
    subtitle?: string;
    valueStyle?: TypographyStyle;
    displayCurrencyValue?: string;
}

export const RiskCard: React.FC<RiskCardProps> = ({
    label,
    value,
    subtitle,
    valueStyle,
    displayCurrencyValue = '',
}) => {
    return (
        <Box
            borderRadius="16px"
            border="1px solid #F18F34"
            overflow="hidden"
            flex={1}
            boxShadow="0px 4px 20px rgba(38, 50, 56, 0.1)"
        >
            <Box bgcolor="#F18F34" paddingY="8px">
                <Typography textAlign="center" color="#FFFCF0" fontSize="24px" lineHeight="34px">
                    {label}
                </Typography>
            </Box>
            <Box paddingX="16px" paddingBottom={'5%'} paddingTop={'5%'}>
                {
                    // display text or number or currency
                    (typeof value === 'number' || typeof value === 'string') && (
                        <Typography
                            textAlign="center"
                            marginY="16px"
                            fontSize="24px"
                            lineHeight="34px"
                            fontWeight="500"
                            color="#686867"
                            style={valueStyle}
                        >
                            {
                                // format if value is currency value else just show text
                                displayCurrencyValue ? (
                                    <DisplayCurrency
                                        centsAmount={value}
                                        disableStyling
                                        usersCurrency={displayCurrencyValue}
                                    />
                                ) : (
                                    value
                                )
                            }
                        </Typography>
                    )
                }
                {
                    /**
                     * TODO: Create or use a src/components/Card instead of inconsistent non-standardised display cards
                     * display custom component but still use typography styles
                     * (usages: CheckInCalls Dashboard / Merchant Risk Level in Summary Information Add Merchant)
                     * (not display currency or text or number)
                     * */
                    !displayCurrencyValue &&
                        isValidElement(value) &&
                        !(typeof value === 'number' || typeof value === 'string') && (
                            <Typography
                                textAlign="center"
                                marginY="16px"
                                fontSize="24px"
                                lineHeight="34px"
                                fontWeight="500"
                                color="#686867"
                                style={valueStyle}
                            >
                                {value}
                            </Typography>
                        )
                }
                {subtitle && (
                    <Typography
                        textAlign="center"
                        fontSize="16px"
                        lineHeight="24px"
                        fontWeight="400"
                        color="#686867"
                        style={valueStyle}
                    >
                        {subtitle}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};
